
  import React from "react"
  import Component from "/Users/nweggen/Projects/ibgs-baublog/src/layouts/index.js"
  import data from "/Users/nweggen/Projects/ibgs-baublog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js